module.exports = __webpack_public_path__ + "img/video_paly_large.8c9f31ba.png";